export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
        authority: process.env.REACT_APP_AZURE_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URL,

        postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URL
    },
    system: {
        iframeHashTimeout: 10000,
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["openid", "profile", "User.Read", "User.ReadWrite.All"],
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const apiRequest = {
    scopes: [process.env.REACT_APP_AZURE_API_SCOPE, "User.ReadWrite.All"],
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};